import clsx from 'clsx';

import { Text } from '@highlight-cp/core-ui';

import classes from './inline-editable-input-max-length.module.css';

interface InlineEditableInputMaxLengthProps {
  maxLength: number;
  currentLength: number;
  shouldFlashMaxLength?: boolean;
}

const InlineEditableInputMaxLength = ({
  maxLength,
  currentLength,
  shouldFlashMaxLength = false,
}: InlineEditableInputMaxLengthProps) => {
  return (
    <span className={clsx(shouldFlashMaxLength && classes.flash)}>
      <Text size="sm" c="var(--mantine-color-error)" role="alert" aria-live="polite" aria-atomic>
        {currentLength} / {maxLength}
      </Text>
    </span>
  );
};

export default InlineEditableInputMaxLength;
